var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "timezone-select" },
    [
      _c("CabTextField", {
        staticClass: "timezone-select__input",
        attrs: { label: "", name: "timezone-select", autocomplete: "off" },
        on: {
          blur: _vm.onFormInputBlur,
          focus: function ($event) {
            _vm.activeList = true
          },
        },
        scopedSlots: _vm._u([
          {
            key: "appendedIcon",
            fn: function () {
              return [
                _vm.selectableTimezonesListIsEmpty
                  ? _c("img", {
                      attrs: {
                        src: require("@icons/arrow-closed.svg"),
                        alt: "arrow-closed.svg",
                      },
                      on: {
                        click: function ($event) {
                          _vm.activeList = true
                        },
                      },
                    })
                  : _c("img", {
                      attrs: {
                        src: require("@icons/arrow-open.svg"),
                        alt: "arrow-open.svg",
                      },
                      on: {
                        click: function ($event) {
                          _vm.activeList = false
                        },
                      },
                    }),
              ]
            },
            proxy: true,
          },
        ]),
        model: {
          value: _vm.input,
          callback: function ($$v) {
            _vm.input = $$v
          },
          expression: "input",
        },
      }),
      _vm._v(" "),
      _c(
        "ItemsBox",
        {
          staticClass: "timezone-select__timezones-list",
          attrs: {
            "key-string": "name",
            "is-empty": _vm.selectableTimezonesListIsEmpty,
          },
        },
        _vm._l(_vm.selectableTimezones, function (timezone) {
          return _c(
            "div",
            {
              key: timezone.id,
              staticClass: "items-box__item",
              attrs: { tabindex: "0" },
              on: {
                click: function ($event) {
                  return _vm.selectTimezone(timezone)
                },
                keyup: function ($event) {
                  if (
                    !$event.type.indexOf("key") &&
                    _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                  )
                    return null
                  return _vm.selectTimezone(timezone)
                },
                focus: _vm.onTimezonesListFocus,
                blur: _vm.onTimezonesListBlur,
              },
            },
            [_vm._v("\n      " + _vm._s(timezone.name) + "\n    ")]
          )
        }),
        0
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }